export const IconContainerSize = 48;
export const SpacingBetweenMenuItems = 46;

export const EXIT_ANIMATION_DURATION = 0.1;
